<template>
  <div ref="container" />
</template>

<script>
  import AccountManageAgencyUsers from './AccountManageAgencyUsers.svelte';

  export default {
    name: 'AccountManageAgencyUsers',
    props: {
      isAdmin: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      isAdmin() {
        if (this.svelteComponent) {
          this.svelteComponent.$set(this.propsProvider());
        }
      }
    },
    mounted() {
      this.svelteComponent = new AccountManageAgencyUsers({
        target: this.$refs.container,
        props: this.propsProvider()
      });
    },
    destroyed() {
      if(this.svelteComponent) {
        this.svelteComponent.$destroy();
      }
    },
    methods: {
      propsProvider() {
        return JSON.parse(JSON.stringify({ isAdmin: this.isAdmin }));
      },
    },
  }
</script>
